// extracted by mini-css-extract-plugin
module.exports = {"tt_container":"Tooltip_tt_container__N6mmu","tt_heading":"Tooltip_tt_heading__3NSe3"};